import Modal from "@via/components/modal.tsx";
import { type ReactNode } from "react";

type HowItWorksModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: ReactNode;
  children: ReactNode;
};

export default function HowItWorksModal({
  open,
  setOpen,
  title,
  children,
}: HowItWorksModalProps): JSX.Element {
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title={title}
      showButtons={false}
      width={960}
      minHeight={420}>
      {children}
    </Modal>
  );
}
